module.exports = __webpack_public_path__ + "static/img/4 诗歌音乐会.fdfd320.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/4 诗歌音乐会.png
// module id = NnBq
// module chunks = 1